import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/Index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'Index',
      path: '/',
      component: Index,
      meta: {
        title: '暖心聊APP-让每一次相遇都触动真心！'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js